<script setup lang="ts">
import { redirectToErrorPage } from '~/router'

onBeforeMount(() => {
  redirectToErrorPage()
})
</script>

<template>
  <div />
</template>

<route lang="yaml">
name: index
meta:
  layout: empty
  requiresAuth: true
</route>
